import { useUIStore, type Toast } from '@/stores/ui.store'
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'

const icons: Record<Toast['type'], React.ReactNode> = {
  success: <CheckCircle className="h-5 w-5 text-green-500" />,
  error:   <AlertCircle className="h-5 w-5 text-red-500" />,
  info:    <Info className="h-5 w-5 text-blue-500" />,
  warning: <AlertTriangle className="h-5 w-5 text-yellow-500" />,
}

const bgColors: Record<Toast['type'], string> = {
  success: 'bg-green-50 border-green-200',
  error:   'bg-red-50   border-red-200',
  info:    'bg-blue-50  border-blue-200',
  warning: 'bg-yellow-50 border-yellow-200',
}

export function ToastContainer() {
  const toasts = useUIStore((s) => s.toasts)
  const remove = useUIStore((s) => s.removeToast)

  if (toasts.length === 0) return null

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            'flex items-start gap-3 rounded-lg border p-4 shadow-lg animate-[slide-in_0.3s_ease-out]',
            bgColors[t.type],
          )}
        >
          {icons[t.type]}
          <p className="flex-1 text-sm text-gray-800">{t.message}</p>
          <button onClick={() => remove(t.id)} className="text-gray-400 hover:text-gray-600">
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )
}
